export const text = 0;
export const capteur = 1;
export const graphe = 2;
export const vue = 3;
